import React, { useContext, useState } from 'react';
import { DataGrid } from '@mui/x-data-grid';
import { Paper, Grid, Typography, Button } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { ImageSearchContext } from '../../components/ImageSearchQueryContext';

const useStyles = makeStyles(() => ({
    header: {
        '& .MuiDataGrid-columnHeader': {
            background: '#E6D6D180 !important'
        },
        '& .MuiDataGrid-columnSeparator.MuiDataGrid-columnSeparator--sideRight': {
            display: 'none',
        },
        '& .MuiDataGrid-filler': {
            display: 'none',
        }
    }
}));

const ImageSearchDailyResult = ({ searchQueryResponse, fetchBatchRecords, handlePrintPdf }) => {
    const { setSearchQueryContext, searchQueryContext } = useContext(ImageSearchContext);
    const classes = useStyles();
    const [selectedRows, setSelectedRows] = useState([]);

    const columns = [
        {
            field: 'batchNumber', headerName: 'Batch', flex: 1,
            renderCell: (params) => (<div style={{ cursor: 'pointer', color: '#1976d2', fontWeight: 500 }}
                onClick={() => handleRowClick(params.row)}>{params.row.batchNumber}</div>)
        },
        { field: 'totalItems', headerName: 'Batch Total Items', flex: 1, },
        { field: 'totalAmount', headerName: 'Batch Total Amount', flex: 1, },
    ];
    const paginationModel = { page: 0, pageSize: 2 };

    const handleRowClick = (row) => {
        setSearchQueryContext({ ...searchQueryContext, batchNumberFrom: row?.batchNumber, batchNumberTo: row.batchNumber });
        fetchBatchRecords();
    };

    const handlePrintPdfWithSelectedRows = async (batchNumbers, param) => {
        if (!batchNumbers || batchNumbers.length === 0) {
            alert('At least one Batch Number is required.');
            return;
        }

        const url = `https://demo-api.incedopay.com/api/sso-service/document-download/0/${param}/${batchNumbers.join(',')}`;

        try {
            const response = await fetch(url, {
                method: 'GET',
                headers: {
                    'accept': '*/*'
                }
            });

            if (response.ok) {
                const blob = await response.blob();
                const pdfUrl = window.URL.createObjectURL(blob);
                window.open(pdfUrl, '_blank');
            } else {
                alert('Failed to download the PDF.');
            }
        } catch (error) {
            console.error('Error fetching the PDF:', error);
            alert('An error occurred while downloading the PDF.');
        }
    };

    return searchQueryResponse?.batches ? (
        <Grid container sx={{ padding: '24px' }}>
            <Paper sx={{ width: '100%' }}>
                <Grid item sx={{ background: '#FAFAFA' }}>
                    <Typography sx={{ padding: '12px 16px', fontSize: '16px', color: '#4C4C4C' }}>
                        Batch List
                    </Typography>
                </Grid>
                <div style={{ display: 'flex', flexDirection: 'column' }}>
                    <DataGrid
                        rows={searchQueryResponse?.batches || []}
                        columns={columns}
                        initialState={{ pagination: { paginationModel } }}
                        pageSizeOptions={[2, 4, 6, 8, 10]}
                        checkboxSelection
                        getRowId={(row) => row.batchNumber}
                        onRowSelectionModelChange={(batchNumber) => setSelectedRows(batchNumber)}
                        sx={{ border: 0 }}
                        disableColumnFilter
                        disableColumnSorting
                        disableAutosize
                        disableColumnMenu
                        disableColumnResize
                        disableColumnSelector
                        classes={{ root: classes.header }}
                    />
                </div>
            </Paper>
            <Grid container sx={{ justifyContent: 'flex-end', marginTop: '24px', width: '100%' }} spacing={2}>
                <Grid item>
                    <Button
                        onClick={() => handlePrintPdfWithSelectedRows(selectedRows, 'front')}
                        variant='outlined'
                        sx={{ borderRadius: '24px', color: '#008CE6', fontSize: '12px' }}
                    >
                        Print Front of Images(US Lockbox Only)
                    </Button>
                </Grid>
                <Grid item>
                    <Button
                        onClick={() => handlePrintPdfWithSelectedRows(selectedRows, 'All')}
                        variant='contained'
                        sx={{ borderRadius: '24px', background: '#008CE6', fontSize: '12px' }}
                    >
                        View/Print Batch Images
                    </Button>
                </Grid>
            </Grid>
        </Grid>
    ) : null;
};

export default ImageSearchDailyResult;
